import { useContext, useCallback } from 'react';
import _get from 'lodash/get';

import { AuthContext } from 'context/AuthContext';

export default function useStore() {
  const { storeProperties } = useContext(AuthContext);

  const ecomPlatform = _get(storeProperties, 'ecommerce_platform.source', '');

  const getStoreProperty = useCallback(
    (key, defaultValue) => _get(storeProperties, key, defaultValue),
    [storeProperties]
  );

  return {
    storeProperties,
    getStoreProperty,
    ecomPlatform
  };
}
